'use client';

import type { BoxProps } from '@mui/material/Box';

import { varAlpha, mergeClasses } from 'minimal-shared/utils';

import Box from '@mui/material/Box';

import { layoutClasses } from '../core';

// ----------------------------------------------------------------------

export type AuthCenteredContentProps = BoxProps;

export function AuthCenteredContent({
  sx,
  children,
  className,
  ...other
}: AuthCenteredContentProps) {
  return (
    <Box
      className={mergeClasses([layoutClasses.content, className])}
      sx={[
        (theme) => ({
          py: 5,
          px: 3,
          width: 1,
          zIndex: 2,
          boxShadow: theme.vars.customShadows.card,
          border: `1px solid ${theme.vars.palette.shared.paperOutlined}`,
          borderRadius: `${Number(theme.shape.borderRadius) * 1.5}px`,
          backdropFilter: 'blur(18px)',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 'var(--layout-auth-content-width)',
          bgcolor: varAlpha(theme.vars.palette.background.paperChannel, 0.92),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {children}
    </Box>
  );
}
